$('.Tabs').each(function(i, tab) {
    var tabRoot = $(this);
    var tabTrigger = '.TabTrigger';
    var tabContent = '.TabContent';
    var findTabTrigger = tabRoot.find(tabTrigger);
    var findTabContent = tabRoot.find(tabContent);

    findTabTrigger.attr('aria-selected', false);

    findTabTrigger.eq(0).addClass('__active').attr('aria-selected', true);
    findTabContent.eq(0).addClass('__active').prop('hidden', false);
    findTabContent.not(findTabContent.eq(0)).prop('hidden', true);

    findTabTrigger.click(function(e) {
        e.preventDefault();
        var dataSet = $(this).data('set');

        tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
        $(this).attr('aria-selected', true).addClass('__active');

        tabRoot.find(tabContent + '.__active').removeClass('__active');
        const activePanel = tabRoot.find(tabContent + '[data-set="' + dataSet + '"]');
        activePanel.addClass('__active').prop('hidden', false);
        tabRoot.find(tabContent).not(activePanel).prop('hidden', true);
        activePanel[0].dispatchEvent(new CustomEvent('tabs:shown', { bubbles: true }));
        
    });
});
